import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  constructor(private http: HttpClient) {}

  getImagenesPorTipo(tipo) {
    return this.http.get(environment.baseUrl + '/imagenes-pagina/' + tipo);
  }

  getCotizaciones() {
    return this.http.get(environment.baseUrl + '/cotizaciones');
  }

  getInfoAgropecuaria() {
    return this.http.get(environment.baseUrl + '/info-agropecuaria');
  }
}
